import React from 'react';
import { Grid, TextField, Chip } from '@mui/material';

import { Colors } from '../utils/Colors';

interface IProps {
  name: string;
  id: string;
  label: string;
  handleOnChange: (event: any) => void;
  chipValues: string[];
  handleChipDelete: any;
  onBlur: any;
  error: any;
  helperText: any;
}

export function TextFieldWithChips({
  name,
  id,
  label,
  handleOnChange,
  chipValues,
  handleChipDelete,
  onBlur,
  error,
  helperText
}: IProps) {
  const [textBox, setTextBox] = React.useState('');
  return (
    <>
      <Grid item xs={12}>
        <TextField
          fullWidth
          name={name}
          value={textBox}
          onChange={(event) => {
            setTextBox(event.target.value);
          }}
          id={id}
          label={label}
          variant="outlined"
          onKeyUp={(event) => {
            if (event.key === 'Enter') {
              handleOnChange(event);
              setTextBox('');
            }
          }}
          // eslint-disable-next-line react/jsx-props-no-spreading
          onBlur={onBlur}
          error={error}
          helperText={helperText}
        />
      </Grid>
      <Grid
        container
        justifyContent="center"
        rowSpacing={3}
        style={{ marginTop: '-5px' }}
      >
        {chipValues.map((value: string) => (
          <Grid item key={`${value}-${Math.random()}`} xs={3}>
            <Chip
              label={value}
              id={value}
              style={{ backgroundColor: Colors.celeste }}
              onDelete={() => handleChipDelete({ type: name, value })}
            />
          </Grid>
        ))}
      </Grid>
    </>
  );
}
